import { render, staticRenderFns } from "./ShipmentPlannerSignature.vue?vue&type=template&id=5584c842"
import script from "./ShipmentPlannerSignature.vue?vue&type=script&lang=js"
export * from "./ShipmentPlannerSignature.vue?vue&type=script&lang=js"
import style0 from "./ShipmentPlannerSignature.vue?vue&type=style&index=0&id=5584c842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports